export default __webpack_public_path__ + "static/media/rgp_pvh_nca.c4a4efcb.png";